import React from 'react';
import { Animated, ViewStyle } from 'react-native';
import { useTheme } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';

const useAnimatedHeader = () => {
  const navigation = useNavigation();
  const theme = useTheme();
  const scrollY = React.useRef(new Animated.Value(0)).current;
  React.useLayoutEffect(() => {
    navigation.setOptions({
      // @ts-ignore
      headerStyle: {
        elevation: scrollY.interpolate({
          inputRange: [0, 1],
          outputRange: [0, 8],
          extrapolate: 'clamp',
        }),
        shadowColor: theme.colors.disabled,
        shadowOffset: {
          height: scrollY.interpolate({
            inputRange: [0, 1],
            outputRange: [-2, 2],
            extrapolate: 'clamp',
          }),
          width: 8,
        },
        shadowRadius: scrollY.interpolate({
          inputRange: [0, 1],
          outputRange: [0, 4],
          extrapolate: 'clamp',
        }),
        shadowOpacity: 0.35,
        borderColor: theme.colors.surface,
      } as ViewStyle,
    });
  }, [navigation, scrollY, theme.colors.disabled, theme.colors.surface]);

  return React.useCallback(
    Animated.event(
      [
        {
          nativeEvent: { contentOffset: { y: scrollY } },
        },
      ],
      { useNativeDriver: false }
    ),
    []
  );
};

export default useAnimatedHeader;
